<template>
    <ValidationObserver class="pass" ref="form" v-slot="{handleSubmit}">
        <div class="flex">
            <div class="w-full mr-4">
                <ValidationProvider
                    vid="password"
                    :name="$t('modals.Password')"
                    rules="required|minmax:6,25"
                    v-slot="{ errors }"
                >

                    <password-input
                        :placeholder="$t('modals.Password')"
                        name="password"
                        v-model="password"
                        @generate="generatePassword"
                        @input="input"
                    />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
            <div class="w-full">
                <ValidationProvider
                    vid="confirm_password"
                    :name="$t('modals.Confirm_password')"
                    rules="required|minmax:6,25|confirmed:password"
                    v-slot="{ errors }"
                >

                    <password-input
                        :placeholder="$t('modals.Confirm_password')"
                        name="confirm_password"
                        v-model="rePassword"
                        :generator="false"
                        @input="handleSubmit(input)"
                    />

                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
        </div>
        <div class="mt-4 w-full text-right ">
            <vx-tooltip :text="$t('tooltip.Copy_password')" class="inline-flex mr-4">
                <vs-button :disabled="dis" @click="copyPass" color="primary" type="filled" v-bind="$iconData('icon-clipboard', 'fi-rr-clipboard-list-check')"></vs-button>
            </vx-tooltip>
            <vs-button @click="handleSubmit(send)" color="primary" type="filled">{{$t('buttons.Update')}}</vs-button>
        </div>
    </ValidationObserver>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'
import EventBus from '@/store/eventBus'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {copy} from "@/utils/utils";

export default {
    data() {
        return {
            password: '',
            rePassword: '',
            dis: true
        }
    },

    components:{
        ValidationProvider,
        ValidationObserver,
    },

    props: ['popupData', 'popupType', 'popupButton'],

    methods: {
        generatePassword(password) {
            this.rePassword = password
        },

        input() {
            this.dis = false
        },

        copyPass() {
            try {
                copy(this.password)
                this.$vs.notify({ title: this.$t('global.Copy'), text: 'Success', color: 'success', iconPack: 'feather', icon: 'icon-check' })
            } catch (e) {
                this.$vs.notify({ title: this.$t('global.Copy'), text: 'ERROR', color: 'red', iconPack: 'feather', icon: 'icon-close' })
                new ErrorHandler(e).send
            }
        },

        async send() {
            const data = {
                hash: this.popupData.hash,
                password: this.password.trim(),
                confirm_password: this.rePassword.trim()
            }

            try {
                await this.$store.dispatch('userManagement/UPDATE_PASSWORD', data)
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (error) {
                if(error.response && error.response.data && error.response.data.result) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(error).send
            }
        }
    },

    mounted() {
        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>

<style lang="scss">
    .vs-tooltip {
        z-index: 999999999 !important;
    }
</style>
